var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"top":""}},[_c('v-btn',{staticClass:"my-0",attrs:{"slot":"activator","flat":"","small":"","icon":""},on:{"click":function($event){return _vm.downloadOutputForm()}},slot:"activator"},[_c('v-icon',[_vm._v("grid_on")])],1),_c('span',[_vm._v("Экспорт в Excel")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }